export default __webpack_public_path__ + "static/media/arrow-left-light.c30c1ff0.svg";